import { api } from "../api";
import { CommandSentResponseType, SendCommandType } from "../../../types/types";

/**
 * sendCommandById - Function that sends to server a command to be emitted to tracker device  
 * /devices/commands/send  
 * method POST 
 * @async-function
 */
const sendCommandById = async (model: SendCommandType) => {
    const response = await api.post<CommandSentResponseType>(
        `/devices/commands/send?isCommandLine=${model.isCommandLine}&deviceType=${model.deviceType}`, {
            description: model.commandDesc,
            deviceId: model.deviceId,
            deviceImei: model.deviceImei,
            customerId: model.customerId,
            name: model.name,
            email: model.email,
            cameraOptions: model.cameraConfig
        }, {
            headers: {
                'Authorization': `Bearer ${model.token}`
            }
        }
    );
    return response;
};

export default sendCommandById;
